import {REQUEST_SET_DEMOGRAPHIC_QUESTIONS} from './../constants/actionTypes';

export function setDemographicQuestions(params: {studentId: string; answers: {[key: string]: string}}) {
    return {
        type: REQUEST_SET_DEMOGRAPHIC_QUESTIONS,
        ...params,
    };
}
